import { createApp } from 'vue'
import App from './App.vue'
import store from './vuex/store'
import router from './router'
import { OktaAuth } from '@okta/okta-auth-js'
import OktaVue from '@okta/okta-vue'
import './styles/main.scss'
import { createNewRelicAgent } from './scripts/new-relic'

const configResponse = await store.dispatch('getConfiguration')
const config = configResponse.data
const oktaAuth = new OktaAuth({
    issuer: config.okta.issuer,
    clientId: config.okta.clientId,
    redirectUri: config.okta.redirectUri,
    scopes: ['openid', 'profile', 'email'],
    pkce: config.okta.pkce,
    responseMode: 'query',
    postLogoutRedirectUri: config.okta.postLogoutRedirectUri
})

createNewRelicAgent(config)

const loadTableauApi = url => {
    window.tableau = window.tableau || {}

    window.tableau._apiLoaded || (window.tableau._apiLoaded = !0, loadScript(url))
}

const loadScript = url => {
    const script = document.createElement('script')
    script.src = url
    script.async = true

    document.body.append(script)
}

loadTableauApi(config.tableauServer.script)
const app = createApp(App)

app.use(store)
app.use(router)
app.use(OktaVue, { oktaAuth })

app.mount('#app')
